import React, { useRef } from 'react';
import { Hero } from '../components/Hero';
import { QuizExperience } from '../components/QuizExperience';
import { Footer } from '../components/Footer';
import { ExitRibbon } from '../components/ExitRibbon';
interface LandingProps {
  webinarUrl: string;
  youtubeUrl: string;
  instagramUrl: string;
}
export function Landing({
  webinarUrl,
  youtubeUrl,
  instagramUrl
}: LandingProps) {
  const testRef = useRef<HTMLDivElement>(null);
  function handleStart() {
    testRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <div className="flex min-h-full w-full flex-col bg-hueso" data-id="element-163" data-mp="3ezp8x01pgv8">
      <Hero onStart={handleStart} data-id="element-164" data-mp="893t37e0l8s3" />
      <main className="flex-1" data-id="element-165" data-mp="8a6jzfbc7b80">
        <div ref={testRef} data-id="element-166" data-mp="c9xglznjolkg">
          <QuizExperience webinarUrl={webinarUrl} data-id="element-167" data-mp="c84bwpwhsbf3" />
        </div>
      </main>
      <Footer youtubeUrl={youtubeUrl} instagramUrl={instagramUrl} data-id="element-168" data-mp="h9a4mnq5jyom" />
      <ExitRibbon webinarUrl={webinarUrl} data-id="element-169" data-mp="m7leuzkd0b7d" />
    </div>;
}